// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { Material } from '../Classes/Material';
export class EPartsMaterial extends Material {
  override readonly systemComponentNodeType: string = "EPartsMaterial";
  isEPart: boolean;
  zoneId: string;
  ePartProductId: string;
  ePartBusiness: string;
  vendorId: string;
  isNonCatalogEPart: boolean;
  vendorCode: string;
}
